import { render, staticRenderFns } from "./EditSubItem.vue?vue&type=template&id=e64c2f42&"
import script from "./EditSubItem.vue?vue&type=script&lang=js&"
export * from "./EditSubItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports